import { render } from "./EditContractPage.vue?vue&type=template&id=45f2cc9a"
import script from "./EditContractPage.vue?vue&type=script&lang=js"
export * from "./EditContractPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__